import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { formatDateWithTime } from "@/utils/dateFormatters";
import BreadcrumbComponent from "@/components/BreadcrumbComponent";
import { CalendarCheck, CalendarClock } from "lucide-react";
import CardSkeleton from "@/components/CardSkeleton";
import { useVisitsHistory } from "@/hooks/useVisitsHistory";
import { arrivalStatusFunc } from "@/utils/arrivalStatusFunc";
import VisitsHistoryStub from "@/components/VisitsHistoryStub";
import { Typography } from "@/components/ui/typography";

const VisitsHistory = () => {
  const { visitsHistoryData, isLoading } = useVisitsHistory();

  return (
    <div className="flex w-full flex-col p-3">
      <BreadcrumbComponent link={"История посещений"} />
      <div className="mb-6 flex items-center gap-2">
        <CalendarCheck className="h-5 w-5 text-primary" />
        <h2 className="text-xl font-medium text-gray-900">История посещений</h2>
      </div>
      <div className="m:grid-cols-1 grid gap-4">
        {!isLoading && (!visitsHistoryData || visitsHistoryData.length === 0) && (
          <VisitsHistoryStub />
        )}
        {isLoading
          ? [...Array(1)].map((_, index) => <CardSkeleton key={index} />)
          : visitsHistoryData.map((visitHistory) => (
              <Card key={visitHistory.id} className="overflow-hidden">
                <CardHeader className="border-b bg-muted/50 p-4">
                  <div className="flex flex-col gap-2">
                    <div className="group flex items-center gap-3">
                      <div className="rounded-full bg-primary/10 p-2 sm:p-2">
                        <CalendarClock className="h-5 w-5 text-primary" />
                      </div>
                      <Typography
                        variant="h3"
                        className="min-w-[40rem] text-lg font-normal text-gray-800 transition-colors group-hover:text-primary md:min-w-[20rem]"
                      >
                        {formatDateWithTime(visitHistory.start_date)}
                      </Typography>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="space-y-4 p-4">
                  {visitHistory.appointment_list.map((appointment) => (
                    <div key={appointment.appointment_id} className="flex flex-col gap-3">
                      <div className="flex items-center justify-between text-sm">
                        <Typography variant="muted" className="text-muted-foreground">
                          Статус посещения:{" "}
                        </Typography>
                        <Typography variant="p" className="text-base leading-relaxed">
                          {arrivalStatusFunc(appointment.arrival_status)}
                        </Typography>
                      </div>
                      <div className="flex items-center justify-between text-sm">
                        <Typography variant="muted" className="text-muted-foreground">
                          Услуга:{" "}
                        </Typography>
                        <Typography variant="p" className="text-base leading-relaxed">
                          {appointment.service.title}
                        </Typography>
                      </div>
                      <div className="flex items-center justify-between text-sm">
                        <Typography variant="muted" className="pr-2 text-muted-foreground">
                          Бассейн:{" "}
                        </Typography>
                        <Typography variant="p" className="text-right text-base leading-relaxed">
                          {appointment.room.title}
                        </Typography>
                      </div>
                      <div className="flex items-center justify-between text-sm">
                        <Typography variant="muted" className="text-muted-foreground">
                          Тренер:{" "}
                        </Typography>
                        <Typography variant="p" className="text-base leading-relaxed">
                          {appointment.employee.name}
                        </Typography>
                      </div>
                    </div>
                  ))}
                </CardContent>
              </Card>
            ))}
      </div>
    </div>
  );
};

export default VisitsHistory;
